"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconPaintRoller = function IconPaintRoller(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M11 5h25a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H11a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3m25 2H11a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h25a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1m5 3a3 3 0 0 1 2.995 2.824L44 13v3.831a5 5 0 0 1-2.883 4.523l-.204.09-15.298 6.339a1 1 0 0 0-.608.806L25 28.71V30h-2v-1.288a3 3 0 0 1 1.673-2.697l.174-.079 15.3-6.34a3 3 0 0 0 1.847-2.576l.006-.19V13a1 1 0 0 0-.883-.993L41 12h-1v-2zM27 31h-6v9a3 3 0 0 0 3 3l.186-.006C25.785 42.877 27 41.574 27 40zm-4 2h2v7a1 1 0 0 1-.924.997l-.113.004-.109-.007A1 1 0 0 1 23 40z",
    clipRule: "evenodd"
  })));
};

export { IconPaintRoller, IconPaintRoller as default };
